// @flow
import FilterOptionsModal from './FilterOptionsModal';

export default FilterOptionsModal;
